import(/* webpackMode: "eager", webpackExports: ["QualifiedLoadingAnnouncer"] */ "/app/apps/sb-shell/components/qualified/QualifiedLoadingAnnouncer.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.1_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@22.20.5_babel-plugi_b5349e8899742362aeb7b8930f36bfa5/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/builder/clientUtils.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsigExperimentContextProvider"] */ "/app/packages/statsig/src/StatsigExperimentContext.tsx");
